import {
  A11Y_STORAGE_KEY,
  DEFAULT_ACCESSIBILITY_SETTINGS,
  parseSettings,
  type AccessibilitySettings,
} from './types'

function hasStorage(): boolean {
  return typeof globalThis !== 'undefined' && typeof globalThis.localStorage !== 'undefined'
}

export function readSettingsFromStorage(): AccessibilitySettings {
  if (!hasStorage()) return DEFAULT_ACCESSIBILITY_SETTINGS
  try {
    const raw = globalThis.localStorage.getItem(A11Y_STORAGE_KEY)
    return parseSettings(raw)
  } catch {
    return DEFAULT_ACCESSIBILITY_SETTINGS
  }
}

export function writeSettingsToStorage(settings: AccessibilitySettings): void {
  if (!hasStorage()) return
  try {
    globalThis.localStorage.setItem(A11Y_STORAGE_KEY, JSON.stringify(settings))
  } catch {
    // quota or private mode — silently skip
  }
}

export function subscribeToStorage(listener: () => void): () => void {
  if (typeof window === 'undefined') return () => {}
  const handler = (e: StorageEvent) => {
    if (e.key === A11Y_STORAGE_KEY) listener()
  }
  window.addEventListener('storage', handler)
  return () => window.removeEventListener('storage', handler)
}
